/**
 * A config containing properties for tree list
 */
var ListConfigBase = /** @class */ (function () {
    function ListConfigBase() {
    }
    return ListConfigBase;
}());
export { ListConfigBase };
//# sourceMappingURL=list-config-base.js.map